module.exports = __webpack_public_path__ + "img/bank-card-line.4199842f.svg";